<style lang="less" scoped>
  .btn {
    width: 44px;
    height: 44px;
  }
</style>

<template lang="pug">
  img.btn(:src='"@/assets/buttons/top-nav-home@2x.png"')
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header_home_btn.vue